var _ellipse, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAvatarBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 53.652,
    viewBox: "0 0 53.652 53.652",
    width: 53.652,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "themed-fill muted",
    cx: 26.826,
    cy: 26.826,
    fill: "#1d5a71",
    rx: 26.826,
    ry: 26.826
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.131,
    cy: 18.554,
    r: 8.199
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.221 10c-9.472 0-17.221 3.689-17.221 8.2v4.1h34.441v-4.1c0-4.511-7.749-8.2-17.22-8.2z",
    transform: "translate(9.897 20.037)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatarBg);
export default __webpack_public_path__ + "static/media/icon-avatar-bg.b7912256a60c78de027a52e8320a387d.svg";
export { ForwardRef as ReactComponent };